"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IrisTrackEventHandler = void 0;
const BaseType_1 = require("../base/BaseType");
//一个track可能被多个Client发布出去，所以一个track可以同事存在多个TrackEventHandler
class IrisTrackEventHandler {
    constructor(params, engine) {
        this._trackType = 'ILocalTrack';
        this.__onEventFirstFrameDecoded = Function;
        this.__onEventVideoElementVisibleStatus = Function;
        this.__onEventSourceStateChange = Function;
        this._client = params.client;
        this._remoteUser = params.remoteUser;
        this._track = params.track;
        this._trackType = params.trackType;
        this._videoSourceType = params.videoSourceType;
        this._engine = engine;
        switch (this._trackType) {
            case 'ILocalTrack':
                this.__onEventTrackEnded = this.onEventTrackEnded.bind(this);
                this._track.on('track-ended', this.__onEventTrackEnded);
                break;
            case 'ILocalVideoTrack':
                this.__onEventTrackEnded = this.onEventTrackEnded.bind(this);
                this._track.on('track-ended', this.__onEventTrackEnded);
                this.__onEventVideoElementVisibleStatus = this.onEventVideoElementVisibleStatus.bind(this);
                this._track.on('video-element-visible-status', this.__onEventVideoElementVisibleStatus);
                break;
            case 'IRemoteTrack':
                this.__onEventFirstFrameDecoded = this.onEventFirstFrameDecoded.bind(this);
                this._track.on('first-frame-decoded', this.__onEventFirstFrameDecoded);
                break;
            case 'IRemoteVideoTrack':
                this.__onEventFirstFrameDecoded = this.onEventFirstFrameDecoded.bind(this);
                this._track.on('first-frame-decoded', this.__onEventFirstFrameDecoded);
                this.__onEventVideoElementVisibleStatus = this.onEventVideoElementVisibleStatus.bind(this);
                this._track.on('video-element-visible-status', this.__onEventVideoElementVisibleStatus);
                break;
            case 'IBufferSourceAudioTrack':
                this.__onEventSourceStateChange = this.onEventSourceStateChange.bind(this);
                this._track.on('source-state-change', this.__onEventSourceStateChange);
                break;
        }
    }
    onEventTrackEnded() {
        return __awaiter(this, void 0, void 0, function* () {
            switch (this._trackType) {
                case 'ILocalTrack':
                    // 屏幕共享的case
                    if (this._engine.implHelper.isScreenCapture(this._videoSourceType)) {
                        this._engine.implDispatchesMap
                            .get('RtcEngine')
                            ._impl.stopScreenCapture();
                    }
                    break;
                case 'ILocalVideoTrack':
                    break;
            }
        });
    }
    onEventSourceStateChange() {
        if (this._trackType === 'IBufferSourceAudioTrack') {
            let soundId = this._engine.irisClientManager.getLocalAudioTrackPackageBySourceType(BaseType_1.IrisAudioSourceType.kAudioSourceTypeBufferSourceAudio)[0].soundId;
            this._engine.rtcEngineEventHandler.onAudioEffectFinished_46f8ab7(soundId);
        }
    }
    onEventBeautyEffectOverload() {
        //目前没有找到对应的回调
    }
    onEventVideoElementVisibleStatus(data) {
        this._engine.rtcEngineEventHandler.onFirstLocalVideoFrame_ebdfd19(this._videoSourceType, 0, 0, 0);
    }
    onEventFirstFrameDecoded() {
        var _a, _b, _c;
        if (!this._client) {
            return;
        }
        if (this._trackType == 'IRemoteTrack') {
            let connection = {
                channelId: this._client.channelName,
                localUid: this._client.uid,
            };
            let remoteUid = ((_a = this._remoteUser) === null || _a === void 0 ? void 0 : _a.uid) || -1;
            let elapsed = 0;
            this._engine.rtcEngineEventHandler.onFirstRemoteAudioDecoded_c5499bd(connection, remoteUid, elapsed);
            this._engine.rtcEngineEventHandler.onFirstRemoteAudioFrame_c5499bd(connection, remoteUid, elapsed);
        }
        else if (this._trackType == 'IRemoteVideoTrack') {
            let connection = {
                channelId: this._client.channelName,
                localUid: this._client.uid,
            };
            let remoteUid = ((_b = this._remoteUser) === null || _b === void 0 ? void 0 : _b.uid) || -1;
            let elapsed = 0;
            let width = -1;
            let height = -1;
            if (((_c = this._remoteUser) === null || _c === void 0 ? void 0 : _c.hasVideo) && this._remoteUser.videoTrack) {
                let imageData = this._remoteUser.videoTrack.getCurrentFrameData();
                width = (imageData === null || imageData === void 0 ? void 0 : imageData.width) || -1;
                height = (imageData === null || imageData === void 0 ? void 0 : imageData.height) || -1;
            }
            this._engine.rtcEngineEventHandler.onFirstRemoteVideoDecoded_a68170a(connection, remoteUid, width, height, elapsed);
            this._engine.rtcEngineEventHandler.onFirstRemoteVideoFrame_a68170a(connection, remoteUid, width, height, elapsed);
        }
    }
    getTrack() {
        return this._track;
    }
    getRemoteUser() {
        return this._remoteUser;
    }
    getTrackType() {
        return this._trackType;
    }
    release() {
        if (this._trackType == 'ILocalTrack') {
            let track = this._track;
            track.off('track-ended', this.__onEventTrackEnded);
        }
        else if (this._trackType == 'ILocalVideoTrack') {
            let track = this._track;
            track.off('track-ended', this.__onEventTrackEnded);
            track.off('video-element-visible-status', this.__onEventVideoElementVisibleStatus);
        }
        else if (this._trackType == 'IRemoteTrack') {
            let track = this._track;
            track.off('first-frame-decoded', this.__onEventFirstFrameDecoded);
        }
        else if (this._trackType == 'IRemoteVideoTrack') {
            let track = this._track;
            track.off('first-frame-decoded', this.__onEventFirstFrameDecoded);
            track.off('video-element-visible-status', this.__onEventVideoElementVisibleStatus);
        }
    }
}
exports.IrisTrackEventHandler = IrisTrackEventHandler;
